/********************************************************************
* ヘッダー背景色変更
**********************************************************************/
const headerChangeBg = () => {
    const header = document.querySelector('.js_header');
    const trigger = document.querySelector('.js_header_change_bg_trigger');

    // スクロールした時に呼ばれる関数
    const doWhenScroll = () => {
        const scroll = window.scrollY; //スクロール位置
        const targetPos = trigger.getBoundingClientRect().top + scroll; //発火位置

        if (scroll > targetPos || document.body.classList.contains('is_fixed')) {
            header.classList.remove('is_transparent');
        } else {
            header.classList.add('is_transparent');
        }
    }

    doWhenScroll(); // 初回実行
    window.addEventListener('scroll', doWhenScroll);
}

export default headerChangeBg;